







import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'n-Card',
})
export default class Card extends Vue {}
